const info = {
  ZH: { //中文翻译
    title: "\u534A\u6210\u54C1\u4EF6",
    type: "\u7C7B\u578B",
    cid: "ID",
    cver: "\u7248\u672C",
    enterprise: " \u521B\u5EFA\u4F01\u4E1A",
    name: "\u534A\u6210\u54C1\u4EF6\u540D\u79F0",
    frname: "\u534A\u6210\u54C1\u4EF6\u540D\u79F0(\u5916\u6587)",
    csymbol: "\u534A\u6210\u54C1\u4EF6\u53F7",
    ccalReuseRate: " \u8BA1\u7B97\u6240\u5F97\u53EF\u518D\u5229\u7528\u7387",
    cmeaReuseRate: "\u6D4B\u91CF\u6240\u5F97\u53EF\u518D\u5229\u7528\u7387",
    ccalRecycleRate: "\u8BA1\u7B97\u6240\u5F97\u53EF\u56DE\u6536\u5229\u7528\u7387",
    cmeaRecycleRate: "\u6D4B\u91CF\u6240\u5F97\u53EF\u56DE\u6536\u5229\u7528\u7387",
    weight: "\u8D28\u91CF",
    ccreateDate: "\u521B\u5EFA\u65E5\u671F",
    ccheckDate: "\u68C0\u9A8C\u65E5\u671F",
    creleaseDate: "\u53D1\u5E03\u65E5\u671F",
    csimpleCheck: "\u7B80\u5316\u6821\u9A8C\u89C4\u5219",
    rate: "\u6BD4\u4F8B",
    ratefrom: "\u4ECE",
    rateto: "\u5230",
    ratecrate: "\u56FA\u5B9A\u7684",
    ratecrateType: "\u5269\u4F59\u7684",
    cdensity:"\u5BC6\u5EA6"
  },
  EN: { //英文翻译
    title: "	Semicomponent",
    type: "	Type",
    cid: "	ID",
    cver: "	Version",
    enterprise: "Supplier ",
    name: "	Article  Name",
    frname: "Name of SemiComponent in foreign language ",
    csymbol: "	Semicomponent No.",
    ccalReuseRate: "	calculated recyclability rate",
    cmeaReuseRate: "	Measured recyclability rate",
    ccalRecycleRate: "  Calculated recoverability rate",
    cmeaRecycleRate: "	Measured recoverability rate",
    weight: "	Mass",
    ccreateDate: "	Creation date",
    ccheckDate: "	Check date",
    creleaseDate: "	Release date",
    csimpleCheck: "	Simplified Check Rules",
    rate: "	Proportion",
    ratefrom: "	From",
    rateto: "	To",
    ratecrate: "	Fixed",
    ratecrateType: "	Rest",
    cdensity:"Specific weight"
  }
}
export default info //需要暴露出去
